import React, { useState } from 'react';
import { Terminal, Award, Eye } from 'lucide-react';
import { usePortfolioTranslation } from '../../hooks/usePortfolioTranslation';
import { useTranslation } from '../../hooks/useTranslation';

export const ProjectCard = ({ title, description, tags, winner, logo, onClick, translationKey }) => {
    const { translateProject } = usePortfolioTranslation();
    const { t } = useTranslation();
    const [imageError, setImageError] = useState(false);

    const translatedProject = translateProject(translationKey);
    const displayTitle = translatedProject?.title || title;
    const displayDescription = translatedProject?.description || description;

    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <div
            className="group relative overflow-hidden rounded-xl bg-[#141414] border border-[#732424]/30 hover:border-[#d92323] transition-all duration-300 h-full flex flex-col cursor-pointer"
            onClick={onClick}
        >
            {winner && (
                <div className="absolute top-4 right-4 bg-[#d92323] text-white text-[10px] uppercase tracking-wider font-bold px-3 py-1 rounded-full z-10 flex items-center gap-1 shadow-lg">
                    <Award className="w-3 h-3" />
                    {t('winner')}
                </div>
            )}
            <div className="p-6 flex flex-col h-full relative z-0">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                        {logo && !imageError ? (
                            <img
                                src={logo}
                                alt={`${title} logo`}
                                className="w-12 h-12 rounded-lg object-contain transition-transform group-hover:scale-110 duration-300"
                                onError={handleImageError}
                            />
                        ) : (
                            <div className="p-3 bg-[#0d0d0d] rounded-lg border border-[#732424]/20 group-hover:border-[#d92323]/50 transition-colors">
                                <Terminal className="w-6 h-6 text-[#d92323]" />
                            </div>
                        )}
                    </div>
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="p-2 bg-[#d92323]/10 rounded-lg border border-[#d92323]/20">
                            <Eye className="w-4 h-4 text-[#d92323]" />
                        </div>
                    </div>
                </div>

                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#d92323] transition-colors">{displayTitle}</h3>
                <p className="text-[#7b7b7b] text-sm mb-6 flex-grow leading-relaxed whitespace-pre-line">{displayDescription}</p>

                <div className="flex flex-wrap gap-2 mt-auto pt-4 border-t border-[#732424]/10">
                    {tags.slice(0, 4).map((tag, idx) => (
                        <span key={idx} className="text-[10px] font-mono text-[#ffffff]/80 bg-[#2a1616] px-2 py-1 rounded border border-[#732424]/30">
                            {tag}
                        </span>
                    ))}
                    {tags.length > 4 && (
                        <span className="text-[10px] font-mono text-[#7b7b7b] bg-[#0d0d0d] px-2 py-1 rounded border border-[#732424]/30">
                            +{tags.length - 4} more
                        </span>
                    )}
                </div>
            </div>
            {/* Abstract hover effect background */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#d92323]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
        </div>
    );
};